module.exports = __webpack_public_path__ + "img/site_summary.d90bf49a.svg";